module.exports = __webpack_public_path__ + "img/06_uk.2ee80fe6.svg";